module.exports = __webpack_public_path__ + "assets/img/Edito_Mathieu-Vedrenne_cover.edb4dc55-ps.jpg";